import React from "react";
import HighlightedText from "../../../../components/HighlightKeyword";

export default function TitleReprintDate({
  documentList,
  openModal,
  query,
  getArrowIcon,
  handleSortDocument,
  handleSortTitle,
}) {
  const renderEgDocumentTitles = (egDocument) => {
    const mainTitleBM = egDocument?.egDocumentDto?.actTitleBM;
    const mainTitleBI = egDocument?.egDocumentDto?.actTitleBI;
    const titles = egDocument?.egDocumentDto?.titles;

    return (
      <>
        {mainTitleBI && (
          <HighlightedText paragraph={mainTitleBI} keyword={query} />
        )}
        {titles !== undefined &&
          titles !== null &&
          titles.length > 0 &&
          titles.map((title) =>
            title.titleBI ? (
              <div key={title?.egTitleId} className="egTitle-title">
                <p>{title.no}</p>
                <HighlightedText paragraph={title?.titleBI} keyword={query} />
                <br />
              </div>
            ) : null
          )}
        {mainTitleBM && (
          <HighlightedText paragraph={mainTitleBM} keyword={query} />
        )}

        {titles !== undefined &&
          titles !== null &&
          titles.length > 0 &&
          titles.map((title) =>
            !title?.titleBI && title?.titleBM ? (
              <div key={title?.egTitleId} className="egTitle-title">
                <p>{title.no}</p>
                <HighlightedText paragraph={title?.titleBM} keyword={query} />
                <br />
              </div>
            ) : null
          )}
      </>
    );
  };

  return (
    <table className="case-law-table">
      <thead>
        <tr>
          <th style={{ width: "80%" }} onClick={() => handleSortDocument("no")}>
            <div className="case-law-table-header">
              Title {getArrowIcon("no")}
            </div>
          </th>
          <th
            style={{ width: "20%" }}
            onClick={() => handleSortDocument("publicationDate")}
          >
            <div className="case-law-table-header">
              Reprint Date {getArrowIcon("publicationDate")}
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        {documentList.map((item) => (
          <tr key={item.documentId}>
            <td onClick={() => openModal(item?.documentBlobDto?.fileUUID, 1)}>
              {renderEgDocumentTitles(item)}
            </td>
            <td style={{ textAlign: "center" }}>
              {new Date(
                item?.egDocumentDto?.publicationDate
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
